import { useEffect } from 'react';

import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { useSnapshot } from 'valtio';

import { CATALYST_USER_ROLES } from '../../../utils/constants.js';

import { authState } from '../../../services/state/auth-state.jsx';
import Loading from '../../feedback/loading.jsx';

export const CustomerAuthenticationWrapper = ({ children }) => {
  const { user } = useSnapshot(authState);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || user?.details.role !== CATALYST_USER_ROLES.customer) {
      navigate('/');
    }
  }, []);

  if (!user) {
    return <Loading />;
  }

  return (
    <div className="flex min-h-[100svh] flex-col items-center justify-center">
      <Helmet>
        <title>Portal de Campanhas - MAR SHOPPING</title>
      </Helmet>

      {user.details.role !== CATALYST_USER_ROLES.customer ? (
        <Loading />
      ) : (
        children
      )}
    </div>
  );
};
